import { Addon, AddonDetails } from "../api/entities/Addon";
import { GenerateUuid } from "utils/Generators";

export const GetAddonPrice = (
  addon: Addon | AddonDetails,
  productGroupId?: string,
): number => {
  if (!productGroupId) {
    return addon.price;
  }
  const specialPricing = addon.specialPricingList?.find(
    (sp) => sp.productGroupId === productGroupId,
  );
  return specialPricing?.price ?? addon.price;
};

export const GetDiscountPrice = (price: number, discount: number): number => {
  return price - price * discount;
};

export const ConvertToAddonDetails = (addon: Addon): AddonDetails => {
  return {
    id: GenerateUuid(),
    referenceId: addon.id,
    name: addon.name,
    description: addon.description,
    addonBillingType: addon.addonBillingType,
    addonAllowedTypes: addon.addonAllowedTypes,
    price: addon.price,
    netCommissionableRevenue: addon.netCommissionableRevenue,
    contractLengthDictionary: addon.contractLengthDictionary,
    customizableStartDateAndContractLength:
      addon.customizableStartDateAndContractLength,
    onlySpecialPricing: addon.onlySpecialPricing,
    specialPricingList: addon.specialPricingList,
  };
};
